<template>
    <div>
        <div class="bg-white shadow-sm p-3 my-3" style="border-radius: 10px">
            <div class="d-flex align-items-center justify-content-between">
                <div v-show="show_title">
                    <span>برداشت های کیف پول</span>
                </div>
                <div class="mr-auto d-flex align-content-center my-2">
                    <div>
                        <button
                                @click="exportToExcel()"
                                class="btn btn border bg-white shadow-sm mx-2 px-4 py-2"
                                style="border-radius: 20px; border-color: #bbb"
                                type="button"
                        >
                            <svg
                                    enable-background="new 0 0 24 24"
                                    fill="#00bea5"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    width="24"
                                    xmlns="http://www.w3.org/2000/svg"
                            >
                                <g>
                                    <rect fill="none" height="24" width="24"/>
                                </g>
                                <g>
                                    <path
                                            d="M16.59,9H15V4c0-0.55-0.45-1-1-1h-4C9.45,3,9,3.45,9,4v5H7.41c-0.89,0-1.34,1.08-0.71,1.71l4.59,4.59 c0.39,0.39,1.02,0.39,1.41,0l4.59-4.59C17.92,10.08,17.48,9,16.59,9z M5,19c0,0.55,0.45,1,1,1h12c0.55,0,1-0.45,1-1s-0.45-1-1-1H6 C5.45,18,5,18.45,5,19z"
                                    />
                                </g>
                            </svg>
                            <span class="pr-2">خروجی اکسل</span>
                        </button>
                    </div>
                    <div class="btn-width-100">
                        <router-link
                                class="btn btn-success my-2 btn-width-100"
                                to="/wallets"
                        >{{ $t('label.back') }}
                        </router-link
                        >
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <input
                                class="form-control kt-selectpicker"
                                id="filter_from_amount"
                                placeholder="از مبلغ"
                                v-model="filter_from_amount"
                        >
                    </div>
                </div>
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <input
                                class="form-control kt-selectpicker"
                                id="filter_to_amount"
                                placeholder="تا مبلغ"
                                v-model="filter_to_amount"
                        >
                    </div>
                </div>
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <datePicker
                                clearable
                                color="#00c1a4"
                                display-format="dddd jDD jMMMM jYYYY HH:mm"
                                format="YYYY-MM-DD HH:mm:ss"
                                id="filter_from_date"
                                input-class="form-control"
                                name="filter_from_date"
                                placeholder="از تاریخ"
                                type="datetime"
                                v-model="filter_from_date"
                        />
                    </div>
                </div>
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <datePicker
                                clearable
                                color="#00c1a4"
                                display-format="dddd jDD jMMMM jYYYY HH:mm"
                                format="YYYY-MM-DD HH:mm:ss"
                                id="filter_to_date"
                                input-class="form-control"
                                name="filter_to_date"
                                placeholder="تا تاریخ"
                                type="datetime"
                                v-model="filter_to_date"
                        />
                    </div>
                </div>
                <div class="col-sm my-2">
                    <div class="d-flex">
                        <button
                                :class="query ? 'btn btn-success' : 'btn btn-success btn-block'"
                                @click="get_data(transactions.first_page_url)"
                                style="border-radius: 10px"
                        >
                            اعمال فیلتر
                        </button>
                        <button
                                @click="reset_and_get"
                                class="btn btn-danger mr-1"
                                style="border-radius: 10px"
                                v-if="query"
                        >
                            حذف فیلتر
                        </button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <select
                                class="form-control kt-selectpicker"
                                id="filter_status"
                                v-model="filter_status"
                        >
                            <option :value="null" disabled selected>وضعیت</option>
                            <option :value="1" v-text="$t('label.pending')"></option>
                            <option :value="2" v-text="$t('label.success')"></option>
                            <option :value="3" v-text="$t('label.failed')"></option>
                            <option :value="4" v-text="$t('label.canceled')"></option>
                            <option :value="6" v-text="$t('label.unknown_yet')"></option>
                            <option :value="-2" v-text="$t('label.reversal')"></option>
                        </select>
                    </div>
                </div>
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <select
                                class="form-control kt-selectpicker"
                                id="filter_type"
                                v-model="filter_type"
                        >
                            <option :value="null" disabled selected>نوع</option>
                            <option :value="400" v-text="$t('wallets.label.custom_wage_iban_info')"></option>
                            <option :value="301" v-text="$t('wallets.label.refund')"></option>
                            <option :value="300" v-text="$t('wallets.label.settlement')"></option>
                        </select>
                    </div>
                </div>
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <input
                                class="form-control kt-selectpicker"
                                id="filter_transaction_hashid"
                                placeholder="شناسه تراکنش"
                                v-model="filter_transaction_hashid"
                        >
                    </div>
                </div>
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <input
                                class="form-control kt-selectpicker"
                                id="filter_iban"
                                placeholder="شبای مقصد"
                                v-model="filter_iban"
                        >
                    </div>
                </div>
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <input
                                class="form-control kt-selectpicker"
                                id="filter_user_track_id"
                                placeholder="کد پیگیری کاربر"
                                v-model="filter_user_track_id"
                        >
                    </div>
                </div>
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <input
                                class="form-control kt-selectpicker"
                                id="filter_destination_last_name"
                                placeholder="نام صاحب حساب مقصد"
                                v-model="filter_destination_last_name"
                        >
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-white shadow-sm py-3 my-2" style="border-radius: 10px">
            <div class="px-3">
                <div class="table-responsive">
                    <table
                            class="
                            table table-responsive table-borderless
                            text-center
                        "
                    >
                        <thead>
                        <tr>
                            <th
                                    scope="col"
                                    style="
                                        background-color: #eee;
                                        border-radius: 0 16px 16px 0;
                                    "
                            >
                                شناسه
                            </th>
                            <th scope="col" style="background-color: #eee">
                                کیف
                            </th>
                            <th scope="col" style="background-color: #eee">
                                مبلغ (ریال)
                            </th>
                            <th
                                    scope="col"
                                    style="
                                        background-color: #eee;
                                        cursor: pointer;
                                    "
                            >
                                <span class="mx-2">وضعیت</span>
                            </th>
                            <th scope="col" style="background-color: #eee">
                                کارمزد
                            </th>
                            <th scope="col" style="background-color: #eee">
                                تاریخ ایجاد
                            </th>
                            <th scope="col" style="background-color: #eee">
                                بانک
                            </th>
                            <th scope="col" style="background-color: #eee">
                                کد پیگیری
                            </th>
                            <th scope="col" style="background-color: #eee">
                                نوع
                            </th>
                            <th
                                    scope="col"
                                    style="
                                        background-color: #eee;
                                        border-radius: 16px 0 0 16px;
                                    "
                            >
                                توضیحات
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                                :key="index"
                                v-for="(
                                    transaction, index
                                ) in transactions.data"
                        >
                            <td class="en_num py-3">
                                {{ transaction.id }}
                            </td>
                            <td class="py-3">
                                {{ transaction.wallet.title }}
                            </td>
                            <td class="py-3">{{ transaction.amount }}</td>
                            <td class="py-3">
                                    <span
                                            :class="[
                                            'label label-inline' +
                                                ' label-light-' +
                                                walletTransactionStatusVariant(
                                                    transaction.status,
                                                    (transaction.charge_rev_id !== '')
                                                )
                                        ]"
                                    >{{
                                            walletTransactionStatusStr.get(
                                                transaction.status
                                            ) + ((transaction.charge_rev_id !== '') ? ' ('+$t('label.reversal')+')' : '')
                                        }}</span
                                    >
                            </td>
                            <td class="py-3">{{ transaction.wage }}</td>
                            <td class="py-3">
                                {{ transaction.created_at }}
                            </td>
                            <td class="py-3">
                                {{ getBank(transaction) }}
                            </td>
                            <td class="py-3">
                                {{ transaction.ref_code }}
                            </td>
                            <td class="py-3">
                                    <span
                                            :class="[
                                            'label label-inline' +
                                                ' label-light-' +
                                                walletTransactionTypeVariant(
                                                    transaction.type
                                                )
                                        ]"
                                    >{{
                                            walletTransactionTypeStr.get(
                                                transaction.type
                                            )
                                        }}</span
                                    >
                            </td>
                            <td v-if="transaction.type === 200">
                                <div>
                                    <i
                                            @click="
                                                fetchTransactionData(
                                                    transaction
                                                )
                                            "
                                            class="fas fa-info"
                                            data-target="#fetch_transfer"
                                            data-toggle="modal"
                                            style="
                                                border-radius: 20px;
                                                border-color: #bbb;
                                            "
                                            type="button"
                                    ></i>
                                </div>
                            </td>
                            <td v-else-if="transaction.type === 300 || transaction.type === walletTransactionType.REFUND">
                                <div class="d-flex justify-content-center align-items-center">
                                    <div class="mx-2">
                                        <i
                                            @click="
                                            fetchSettlementData(transaction)
                                        "
                                            class="fas fa-info mx-3"
                                            data-target="#fetch_settlement"
                                            data-toggle="modal"
                                            style="
                                            border-radius: 20px;
                                            border-color: #bbb;
                                        "
                                            type="button"
                                        ></i>
                                    </div>
                                    <div class="mx-2 btn
                                            btn-sm
                                            btn-clean
                                            btn-icon
                                            btn-icon-sm special-tooltip" v-if="transaction.status === walletTransactionStatus.FAILED && transaction.should_send_request" style="cursor: pointer;">
                                        <span @click="openModal(transaction)"  class="fa fa-history"></span>
                                        <span class="tooltip-text"
                                        >ارسال مجدد</span
                                        >
                                    </div>
                                    <div class="mx-2">
                                        <a
                                            @click="
                                            cancelSettlement(transaction.id)
                                        "
                                            class="
                                            btn
                                            btn-sm
                                            btn-clean
                                            btn-icon
                                            btn-icon-sm
                                            special-tooltip
                                            mx-3
                                        "
                                            type="button"
                                            v-if="transaction.status === 1"
                                        >
                                        <span class="tooltip-text"
                                        >لغو برداشت</span
                                        >
                                            <i class="fas fa-times-circle"></i>
                                        </a>
                                    </div>
                                </div>
                            </td>
                            <td v-else-if="true">
                                <span  class="fa fa-history"></span>
                            </td>
                            <td v-else class="">
                              <i
                                  @click="fetchTrx(transaction)"
                                  class="fas fa-info"
                                  data-target="#fetch_transaction"
                                  data-toggle="modal"
                                  style="
                                                border-radius: 20px;
                                                border-color: #bbb;
                                            "
                                  type="button"
                              ></i>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <pagination
                    :data="transactions"
                    :get_data="get_data"
                    :perpage="perpage"
            ></pagination>
        </div>
        <div
                class="modal fade"
                id="fetch_settlement"
                role="dialog"
                tabindex="-1"
                v-show="settlementType"
        >
            <div
                    class="modal-dialog modal-lg modal-dialog-centered"
                    role="document"
            >
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="d-flex justify-content-between">
                            <div class="mx-4">توضیحات</div>
                            <div class="mx-4">
                                <button type="button" class="btn btn-sm btn-circle btn-icon bg-white" data-dismiss="modal" aria-label="Close">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </div>
                        <form class="mt-5 mx-5 mb-2">
                            <div>
                                <div class="row m-2 bg-white p-1 rounded">
                                    <div class="col-12 col-md my-2">
                                        <div>
                                            {{
                                            $t(
                                            'wallets.label.withdraw_type'
                                            )
                                            }}
                                        </div>
                                        <input
                                                :value="
                                                withdrawTypeStr.get(
                                                    fetchSettlement.settlement_withdraw_type
                                                )
                                            "
                                                class="form-control"
                                                disabled
                                        />
                                    </div>
                                    <div class="col-12 col-md my-2">
                                        <div>
                                            {{ $t('label.total_amount') }}
                                        </div>
                                        <input
                                                :value="
                                                fetchSettlement.total_amount
                                            "
                                                class="form-control"
                                                disabled
                                        />
                                    </div>
                                    <div class="col-12 col-md my-2"
                                         v-if="fetchSettlement.user_track_id != '' && fetchSettlement.user_track_id != null">
                                        <div>
                                            {{ $t('label.user_track_id') }}
                                        </div>
                                        <input
                                                :value="fetchSettlement.user_track_id"
                                                class="form-control"
                                                disabled
                                        />
                                    </div>
                                    <div class="col-12 col-md my-2">
                                        <div>{{ $t('label.status') }}</div>
                                        <input
                                                :class="`form-control text-white bg-${walletTransactionStatusVariant(
                                                fetchSettlement.status
                                            )}`"
                                                :value="
                                                walletTransactionStatusStr.get(
                                                    fetchSettlement.status
                                                ) + ((fetchSettlement.charge_rev_id !== '') ? ' ('+$t('label.reversal')+')' : '')
                                            "
                                                disabled
                                        />
                                    </div>
                                    <div
                                            class="col-12 col-md my-2"
                                            v-if="
                                            fetchSettlement.error_message !== ''
                                        "
                                    >
                                        <div>
                                            {{
                                            $t(
                                            'wallets.label.error_message'
                                            )
                                            }}
                                        </div>
                                        <input
                                                :value="
                                                fetchSettlement.error_message
                                            "
                                                class="form-control"
                                                disabled
                                        />
                                    </div>
                                    <div class="row col-12">
                                        <div class="col-12 col-md-6 my-2"
                                             v-if="fetchSettlement.ref_code !== ''"
                                        >
                                            <div>{{ $t('label.ref_code') }}</div>
                                            <input
                                                    :value="fetchSettlement.ref_code"
                                                    class="form-control"
                                                    disabled
                                            />
                                        </div>
                                        <div class="col-12 col-md-6 my-2"
                                             v-if="fetchSettlement.charge_rev_id !== ''"
                                        >
                                            <div>{{ $t('label.charge_rev_id') }}</div>
                                            <input
                                                    :value="fetchSettlement.charge_rev_id"
                                                    class="form-control"
                                                    disabled
                                            />
                                        </div>
                                        <div class="col-12 col-md-6 my-2"
                                             v-if="fetchSettlement.status == 2"
                                        >
                                            <div>تاریخ پرداخت</div>
                                            <input
                                                    :value="fetchSettlement.payment_date"
                                                    class="form-control"
                                                    dir="ltr"
                                                    disabled
                                            />
                                        </div>
                                        <div class="col-12 col-md-6 my-2"
                                             v-if="fetchSettlement.status == 2"
                                        >
                                            <div>زمان تقریبی واریز</div>
                                            <input
                                                    :value="fetchSettlement.approximate_payment_date"
                                                    class="form-control"
                                                    dir="ltr"
                                                    disabled
                                            />
                                        </div>
                                        <div class="col-12 col-md-9 my-2"
                                             v-if="fetchSettlement.status === 2 ||
                                             fetchSettlement.status === 1 ||
                                                fetchSettlement.status === 3">
                                            <div>لینک تسویه</div>
                                            <div class="d-flex align-items-center">
                                                <a target="_blank" :href="fetchSettlement.collection_id !== null
                                                    ?`https://my.paystar.ir/wallets/settlement-receipt/collection/${fetchSettlement.collection_id}`
                                                    : `https://my.paystar.ir/wallets/settlement-receipt/${fetchSettlement.id}`">
                                                <div
                                                    v-text="fetchSettlement.collection_id !== null
                                                    ?`https://my.paystar.ir/wallets/settlement-receipt/collection/${fetchSettlement.collection_id}`
                                                    : `https://my.paystar.ir/wallets/settlement-receipt/${fetchSettlement.id}`"
                                                        class="form-control"
                                                        dir="ltr"
                                                ></div>
                                                </a>
                                                <div
                                                        @click="
                                                        copyText(fetchSettlement.collection_id !== null
                                                    ?`https://my.paystar.ir/wallets/settlement-receipt/collection/${fetchSettlement.collection_id}`
                                                    : `https://my.paystar.ir/wallets/settlement-receipt/${fetchSettlement.id}`)
                                                    "
                                                        class="
                                                        btn
                                                        m-0
                                                        pl-2
                                                        pr-0
                                                        py-1
                                                        border-success
                                                        mr-2
                                                    "
                                                        style="cursor: pointer"
                                                >
                                                    <i
                                                            class="
                                                            fas
                                                            fa-copy
                                                            text-success
                                                        "
                                                            id="btn_copy_wallet_hashid"
                                                    ></i>
                                                </div>
                                              <a
                                                  class="btn m-0 px-2 py-1 border-success mx-2"
                                                  :href="fetchSettlement.collection_id !== null
                                                    ?`https://my.paystar.ir/wallets/settlement-receipt/collection/${fetchSettlement.collection_id}`
                                                    : `https://my.paystar.ir/wallets/settlement-receipt/${fetchSettlement.id}`"
                                                  target="_blank"
                                              >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#01C1A4" class="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                                                  <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"/>
                                                  <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"/>
                                                </svg>
                                              </a>
                                            </div>
                                        </div>
                                        <div
                                            class="col-12 col-md-9 my-2"
                                            v-if="
                                                fetchSettlement.status === 2 ||
                                                fetchSettlement.status === 1 ||
                                                fetchSettlement.status === 3
                                            "
                                        >
                                            <div>لینک کوتاه تسویه</div>
                                            <div
                                                class="d-flex align-items-center"
                                            >
                                                <a
                                                    target="_blank"
                                                    :href="
                                                        fetchSettlement.collection_id !==
                                                        null
                                                            ? `https://payst.ar/c/${fetchSettlement.collection_id}`
                                                            : `https://payst.ar/${fetchSettlement.id}`
                                                    "
                                                >
                                                    <div
                                                        v-text="
                                                            fetchSettlement.collection_id !==
                                                            null
                                                                ? `https://payst.ar/c/${fetchSettlement.collection_id}`
                                                                : `https://payst.ar/${fetchSettlement.id}`
                                                        "
                                                        class="form-control"
                                                        dir="ltr"
                                                    ></div>
                                                </a>
                                                <div
                                                    @click="
                                                        copyText(
                                                            fetchSettlement.collection_id !==
                                                        null
                                                            ? `https://payst.ar/c/${fetchSettlement.collection_id}`
                                                            : `https://payst.ar/${fetchSettlement.id}`,
                                                            'btn_copy_wallet_hashid_short'
                                                        )
                                                    "
                                                    class="btn m-0 pl-2 pr-0 py-1 border-success mr-2"
                                                    style="cursor: pointer"
                                                >
                                                    <i
                                                        class="fas fa-copy text-success"
                                                        id="btn_copy_wallet_hashid_short"
                                                    ></i>
                                                </div>
                                                <a
                                                    class="btn m-0 px-2 py-1 border-success mx-2"
                                                    :href="
                                                        fetchSettlement.collection_id !==
                                                        null
                                                            ? `https://payst.ar/c/${fetchSettlement.collection_id}`
                                                            : `https://payst.ar/${fetchSettlement.id}`
                                                    "
                                                    target="_blank"
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="14"
                                                        height="14"
                                                        fill="#01C1A4"
                                                        class="bi bi-box-arrow-up-right"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
                                                        />
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
                                                        />
                                                    </svg>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-12 my-2">
                                        <div>{{ $t('label.description') }}</div>
                                        <textarea
                                                :value="
                                                fetchSettlement.settlement_data
                                                    .transfer_description
                                            "
                                                class="form-control"
                                                disabled
                                        ></textarea>
                                    </div>
                                </div>

                                <div>
                                    <table
                                            class="table table-bordered bg-white"
                                    >
                                        <tr>
                                            <td
                                                    v-text="
                                                    $t(
                                                        'wallets.label.destination_owner_name'
                                                    )
                                                "
                                            ></td>
                                            <td
                                                    v-text="
                                                    $t(
                                                        'wallets.label.destination_deposit'
                                                    )
                                                "
                                            ></td>
                                            <td
                                                    v-text="$t('label.amount_rial')"
                                            ></td>
                                            <td
                                                    v-if="fetchSettlement
                                                        .payment_id"
                                                    v-text="$t('wallets.label.payment_id')"
                                            ></td>
                                            <td
                                                v-if="fetchSettlement.before_balance != null"
                                                v-text="
                                                        $t(
                                                            'label.wallet_balance_before'
                                                        )
                                                    "
                                            ></td>
                                            <td
                                                v-if="fetchSettlement.after_balance != null"
                                                v-text="
                                                        $t(
                                                            'label.wallet_balance_after'
                                                        )
                                                    "
                                            ></td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {{
                                                fetchSettlement
                                                .settlement_data
                                                .destination_firstname +
                                                ' ' +
                                                fetchSettlement
                                                .settlement_data
                                                .destination_lastname
                                                }}
                                            </td>
                                            <td
                                                    v-text="
                                                    fetchSettlement
                                                        .settlement_data
                                                        .destination_number
                                                "
                                            ></td>
                                            <td
                                                    v-text="
                                                    fetchSettlement
                                                        .settlement_data.amount
                                                "
                                            ></td>
                                            <td v-if="fetchSettlement
                                                        .payment_id"
                                                v-text="
                                                    fetchSettlement
                                                        .payment_id
                                                "
                                            ></td>
                                            <td v-if="fetchSettlement.before_balance != null">{{ fetchSettlement.before_balance }}</td>
                                            <td v-if="fetchSettlement.after_balance != null">{{ fetchSettlement.after_balance }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div
                class="modal fade"
                id="fetch_transfer"
                role="dialog"
                tabindex="-1"
                v-show="transferType"
        >
            <div
                    class="modal-dialog modal-lg modal-dialog-centered"
                    role="document"
            >
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="d-flex justify-content-between">
                            <div class="mx-4">توضیحات</div>
                            <div class="mx-4">
                                <button type="button" class="btn btn-sm btn-circle btn-icon bg-white" data-dismiss="modal" aria-label="Close">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </div>

                        <form class="mt-5 mx-5 mb-2">
                            <div>
                                <div class="row m-2 bg-white p-1 rounded">
                                    <div class="col-12 col-md-4 my-2">
                                        <div>
                                            {{
                                            $t(
                                            'wallets.label.withdraw_type'
                                            )
                                            }}
                                        </div>
                                        <input
                                                :value="fetchTransfer.type === 'transfer'
                                                ? walletTransactionTypeStr.TRANSFER
                                                : withdrawTypeStr.get(
                                                    fetchTransfer.type
                                                )
                                            "
                                                class="form-control"
                                                disabled
                                        />
                                    </div>
                                    <div class="col-12 col-md-4 my-2">
                                        <div>
                                            {{ $t('label.total_amount') }}
                                        </div>
                                        <input
                                                :value="fetchTransfer.amount"
                                                class="form-control"
                                                disabled
                                        />
                                    </div>
                                    <div class="col-12 col-md-4 my-2">
                                        <div>{{ $t('label.status') }}</div>
                                        <input
                                                :class="`form-control text-white bg-${walletTransactionStatusVariant(
                                                fetchTransfer.status
                                            )}`"
                                                :value="
                                                walletTransactionStatusStr.get(
                                                    fetchTransfer.status
                                                )
                                            "
                                                disabled
                                        />
                                    </div>
                                    <div
                                            class="col-12 col-md-12 my-2"
                                            v-if="
                                            fetchTransfer.status === 2 ||
                                            fetchTransfer.status === 3 ||
                                            fetchTransfer.status === 1
                                        "
                                    >
                                        <div>لینک تسویه</div>
                                        <div class="d-flex align-items-center">
                                            <input
                                                    :value="`https://my.paystar.ir/wallets/settlement-receipt/${fetchTransfer.id}`"
                                                    class="form-control"
                                                    dir="ltr"
                                                    disabled
                                                    type="text"
                                            />
                                            <div
                                                    @click="
                                                    copyTextTransfer(fetchTransfer.id)
                                                "
                                                    class="
                                                    btn
                                                    m-0
                                                    pl-2
                                                    pr-0
                                                    py-1
                                                    border-success
                                                    mr-2
                                                "
                                                    style="cursor: pointer"
                                            >
                                                <i
                                                        class="
                                                        fas
                                                        fa-copy
                                                        text-success
                                                    "
                                                        id="btn_copy_wallet_hashid_transfer"
                                                ></i>
                                            </div>
                                            <a
                                                class="btn m-0 px-2 py-1 border-success mx-2"
                                                :href="`https://my.paystar.ir/wallets/settlement-receipt/${fetchTransfer.id}`"
                                                target="_blank"
                                            >
                                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#01C1A4" class="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"/>
                                                <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"/>
                                              </svg>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-12 my-2">
                                        <div>{{ $t('label.description') }}</div>
                                        <textarea
                                                :value="
                                                fetchTransfer.transfer_description
                                            "
                                                class="form-control"
                                                disabled
                                        ></textarea>
                                    </div>
                                </div>

                                <div>
                                    <table
                                            class="table table-bordered bg-white"
                                    >
                                        <tr>
                                            <td
                                                    v-text="
                                                    $t(
                                                        'wallets.receipt.user_to'
                                                    )
                                                "
                                            ></td>
                                            <td
                                                    v-text="
                                                    $t(
                                                        'wallets.receipt.user_from'
                                                    )
                                                "
                                            ></td>
                                            <td
                                                    v-text="
                                                    $t(
                                                        'wallets.receipt.wallet_id_to'
                                                    )
                                                "
                                            ></td>
                                            <td
                                                    v-text="
                                                    $t(
                                                        'wallets.receipt.wallet_id_from'
                                                    )
                                                "
                                            ></td>
                                            <td
                                                v-if="fetchTransfer.before_balance != null"
                                                v-text="
                                                      $t(
                                                          'label.wallet_balance_before'
                                                      )
                                                  "
                                            ></td>
                                            <td
                                                v-if="fetchTransfer.after_balance != null"
                                                v-text="
                                                      $t(
                                                          'label.wallet_balance_after'
                                                      )
                                                  "
                                            ></td>

                                        </tr>
                                        <tr>
                                            <td  v-if="fetchTransfer.from">{{ fetchTransfer.from.user }}</td>
                                            <td v-if="fetchTransfer.to">{{ fetchTransfer.to.user }}</td>
                                            <td  v-if="fetchTransfer.from">{{ fetchTransfer.from.wallet_id }}</td>
                                            <td  v-if="fetchTransfer.to">{{ fetchTransfer.to.wallet_id }}</td>
                                            <td  v-if="fetchTransfer.before_balance != null">{{ fetchTransfer.before_balance }}</td>
                                            <td  v-if="fetchTransfer.after_balance != null">{{ fetchTransfer.after_balance }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="modal fade"
            id="fetch_transaction"
            role="dialog"
            tabindex="-1"
            v-show="settlementType"
        >
          <div
              class="modal-dialog modal-lg modal-dialog-centered"
              role="document"
          >
            <div class="modal-content">
              <div class="modal-body">
                <div class="d-flex justify-content-between">
                  <div>توضیحات</div>
                  <div>
                    <button type="button" class="close border border-danger rounded p-1" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="h6">
                                        <span class="px-2 text-white-in-dark-mode" style="text-shadow: none;">بازگشت</span>
                                        <span class="px-2 text-danger">&times;</span>
                                    </span>
                    </button>
                  </div>
                </div>

                <div>
                  <table
                      class="table table-bordered bg-white"
                  >
                    <tr>
                      <td
                          v-text="$t('label.wallet_balance_before')"
                          v-if="fetchTransaction.before_balance != null"
                      ></td>
                      <td
                          v-text="$t('label.wallet_balance_after')"
                          v-if="fetchTransaction.after_balance != null"
                      ></td>
                    </tr>

                    <tr>
                      <td  v-if="fetchTransaction.before_balance != null">{{ fetchTransaction.before_balance }}</td>
                      <td  v-if="fetchTransaction.after_balance != null">{{ fetchTransaction.after_balance }}</td>
                    </tr>
                  </table>

                </div>
              </div>
          </div>
        </div>
    </div>
        <div class="modal fade" data-backdrop="static" data-keyboard="false"  id="approve_modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <form @submit.prevent="sendRequest" id="send_request_form">
                            <div class="row px-4 justify-content-end">
                                <button type="button" @click="hideModal" class="btn btn-sm btn-circle btn-icon bg-white">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                            <div class="row pr-4 pb-4 w-100">
                                <label for="otp">کیف</label>
                                <input :value="request_data.title" readonly type="text" class="form-control">
                            </div>
                            <div class="row pr-4 pb-4 w-100">
                                <label for="password">رمز کیف</label>
                                <input name="password" v-model="request_data.password" id="password" ref="password" type="password" class="form-control">
                            </div>
                            <div v-if="request_data.show_send_type" class="row pr-4 pb-4 w-100">
                                <label>نوع ارسال</label>
                                <div class="form-check form-check-inline mt-2">
                                    <input
                                        type="radio"
                                        id="single_send"
                                        name="dispatch_type"
                                        class="form-check-input"
                                        :checked="request_data.dispatch_type === 1"
                                        @change="toggleRequestType(1)"
                                    >
                                    <label class="form-check-label ml-2" for="single_send">ارسال فقط همین برداشت</label>
                                </div>
                                <div class="form-check form-check-inline mt-2">
                                    <input
                                        type="radio"
                                        id="group_send"
                                        name="dispatch_type"
                                        class="form-check-input"
                                        :checked="request_data.dispatch_type === 2"
                                        @change="toggleRequestType(2)"
                                    >
                                    <label class="form-check-label ml-2" for="group_send">ارسال همه برداشت‌های این کالکشن</label>
                                </div>
                            </div>

                            <div v-if="hasOtp">
                                <div v-if="request_data.two_factor_type === TwoFactorType.SMS" class="row pr-4 pb-4 w-100">
                                    <label for="otp">رمزیکبار مصرف</label>
                                    <input name="otp" v-model="request_data.otp" id="otp" ref="otp" type="text" class="form-control">
                                    <a v-if="!loading_btn" class="link mt-2 mr-1" @click="changeTwoFactorType(TwoFactorType.GOOGLE_AUTHENTICATOR)">{{$t('label.send_request_with_google')}}</a>
                                    <button v-else :disabled="loading_btn" class="btn btn-link mt-2 mr-1">{{$t('label.send_request_with_google')}}</button>
                                </div>
                                <div v-else class="row pr-4 pb-4 w-100">
                                    <label for="google_authenticator_code">{{$t('auth.login.google_authenticator_code')}}</label>
                                    <kt-form-control
                                        v-bind:placeholder="$t('auth.login.google_authenticator_code')"
                                        name="google_authenticator_code"
                                        class="text-center"
                                        autocomplete="off"
                                        v-model="request_data.otp"
                                        type="text"
                                        id="google_authenticator_code"
                                        dir="ltr"
                                    />
                                    <a v-if="!loading_btn" class="link mt-2 mr-1" @click="changeTwoFactorType(TwoFactorType.SMS)">{{$t('label.send_request_with_sms')}}</a>
                                    <button v-else :disabled="loading_btn" class="btn btn-link mt-2 mr-1">{{$t('label.send_request_with_sms')}}</button>

                                </div>
                            </div>
                            <div class="d-flex px-1 justify-content-end mb-3">
                                <button @click="hideModal()"
                                        type="button"
                                        class="btn btn-danger btn-sm px-5 rounded-pill py-2 ml-2 font-weight-bold"
                                        style="font-size: 14px">انصراف
                                </button>
                                <button  id="approve_button"
                                         :disabled="loading_btn"
                                         class="btn btn-primary btn-sm rounded-pill px-5 py-2 mr-2  font-weight-bold"
                                         style="font-size: 14px">
                                    <span v-if="loading_btn" class="spinner-border"></span>
                                    <span v-else>ارسال</span>
                                </button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ApiUrl } from "@/common/api.service";
    import Pagination from "@/components/main/pagination";
    import Axios from "axios";
    import $ from 'jquery'
    import { ShopApiService, walletService } from "@/common/api.service";
    import {
        walletTransactionType,
        walletTransactionTypeStr,
        walletTransactionTypeVariant
    } from '@/constants/walletTransactionType';
    import {
        walletTransactionStatus,
        walletTransactionStatusStr,
        walletTransactionStatusVariant
    } from '@/constants/walletTransactionStatus'
    import {withdrawType, withdrawTypeStr} from "@/constants/withdrawType";
    import {bankIdStr, bankId} from "@/constants/bankId";
    import {transactionStatus} from "@/constants/transactionStatus";
    import {i18n} from "@/plugins/i18n";
    import {TwoFactorType} from "@/constants/TwoFactorType";
    import Inputmask from "inputmask";

    export default {
        components: {
            Pagination
        },
        props: {
            show_title: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                should_two_factor_settlement: false,
                hasOtp: false,
                loading_btn: false,
                request_data: {
                    password: null,
                    title: null,
                    transaction_id: null,
                    otp: null,
                    wallet_id: null,
                    two_factor_type: TwoFactorType.GOOGLE_AUTHENTICATOR,
                    dispatch_type: 1,
                    show_send_type: false,
                    collection_id: null
                },
                filter_from_amount: null,
                filter_to_amount: null,
                filter_from_date: null,
                filter_to_date: null,
                filter_status: null,
                filter_type: null,
                filter_transaction_hashid: this.$route.query.transfer_id || "",
                filter_user_track_id: '',
                filter_iban: '',
                filter_destination_last_name: '',
                sort_field: null,
                sort_sort: "desc",
                transactions: [],
                perpage: {
                    value: 15
                },
                walletTransactionStatusStr,
                walletTransactionTypeStr,
                walletTransactionTypeVariant,
                walletTransactionStatusVariant,
                withdrawType,
                withdrawTypeStr,
                bankIdStr,
                bankId,
                fetchSettlement: {
                    settlement_withdraw_type: '',
                    total_amount: '',
                    status: null,
                    ref_code: '',
                    transfer_description: '',
                    user_track_id: '',
                    settlement_data: {
                        destination_firstname: '',
                        destination_lastname: '',
                        destination_number: '',
                        amount: '',
                        track_id: '',
                    },
                    before_balance: '',
                    after_balance: '',
                },
                fetchTransfer: {
                    amount: '',
                    type: '',
                    status: null,
                    to: {
                        user: ''
                    },
                    transfer_description: '',
                    before_balance: '',
                    after_balance: '',
                },
                fetchTransaction: {
                  before_balance: '',
                  after_balance: '',
                },
                transferType: false,
                settlementType: false
            };
        },
        methods: {
            toggleRequestType(type) {
                this.request_data.dispatch_type = type;
            },
            masked() {
                setTimeout(() => {
                    document.getElementById("google_authenticator_code") &&
                    Inputmask("9     9     9     9     9     9").mask(document.getElementById("google_authenticator_code"));
                }, 100);
            },
            changeTwoFactorType(type) {
                this.request_data.two_factor_type = type;
                this.request_data.otp = '';
                this.masked();
                if (type === TwoFactorType.SMS) {
                    this.sendOtp($('#send_request_form'))
                }
            },
            sendRequest(event) {
                if (this.should_two_factor_settlement && !this.hasOtp) {
                    this.sendOtp($(event.target));
                } else {
                    let form = $(event.target);

                    let params = {
                        wallet_id: this.request_data.wallet_id,
                        password: this.request_data.password,
                        should_two_factor_settlement: this.should_two_factor_settlement,
                        otp: !this.request_data.otp ? '' : this.request_data.otp.replace(/\s+/g, ''),
                        two_factor_type: !this.request_data.two_factor_type ? "" : this.request_data.two_factor_type ,
                        transaction_id: this.request_data.transaction_id,
                        dispatch_type: this.request_data.dispatch_type,
                        collection_id: this.request_data.collection_id,
                    }

                    this.loading_btn = true;

                    walletService.resendSettlement(params).then(response => {
                        this.hideModal();
                        this.getSettlementList();

                        this.toastr.success(response.data.message);

                    }).catch(({response}) => {
                        this.showMsg(form, 'danger', response.data.message);

                        if (response.data && response.data.data) {
                            form.validate().showErrors(response.data.data);
                        }
                    }).finally(() => {
                        this.loading_btn = false;
                    });

                }


            },
            sendOtp(form) {
                form.validate({
                    ignore: ":hidden",
                    rules: {
                        password: {
                            required: true
                        }
                    }
                });

                if (!form.valid()) return false;

                let params = {
                    wallet_id: this.request_data.wallet_id,
                    two_factor_type: this.request_data.two_factor_type,
                    password: this.request_data.password,
                }

                this.loading_btn = true;

                walletService.sendVerificationCode(params).then(response => {
                    this.hasOtp = true;
                    this.request_data.two_factor_type = response.data.data.two_factor_type;
                    this.masked();

                    this.toastr.success(response.data.message);

                }).catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message);

                    if (response.data && response.data.data) {
                        form.validate().showErrors(response.data.data);
                    }
                }).finally(() => {
                    this.loading_btn = false;
                });
            },
            openModal(tr) {
                this.request_data.title = tr.wallet.title;
                this.request_data.wallet_id = tr.wallet_hashid;
                this.request_data.transaction_id = tr.id;

                this.request_data.show_send_type = !!tr.collection_id;
                this.request_data.collection_id = tr.collection_id;
                $('#approve_modal').modal('show');
            },
            hideModal() {
                this.request_data.otp = null;
                this.hasOtp = false;
                this.request_data.two_factor_type = TwoFactorType.GOOGLE_AUTHENTICATOR;
                this.masked();
                $('#approve_modal').modal('hide');
            },
            emitAction(data) {

            },
            getBank(transaction) {
                if (transaction.bank_id !== '-') {
                        if (transaction.destination_bank_id !== '-') {
                            return `${bankIdStr.get(transaction.bank_id)} به ${bankIdStr.get(transaction.destination_bank_id)}`;
                        }

                        return `${bankIdStr.get(transaction.bank_id)}`;
                    }

                return '-';
            },
            exportToExcel() {
                let hashid = this.wallet_hashid;
                let query = this.queryForExcel;
                Axios({
                    url: ApiUrl.path(`wallet/common/transactions-excel-report/${hashid}?${query}`),
                    method: "GET",
                    responseType: "blob",
                }).then((response) => {
                    let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    let fileLink = document.createElement("a");

                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", "settlements.xlsx");
                    document.body.appendChild(fileLink);

                    fileLink.click();
                });
            },
            cancelSettlement(id) {
                walletService
                    .cancelSettlement(id)
                    .then((response) => {
                        this.getSettlementList();
                        this.toastr.success(response.data.message);
                    });
            },
            get_data(url, callback = () => {
            }) {
                this.status = 'loading';
                ShopApiService.query(url + this.query + '&perpage=' + this.perpage.value).then(
                    (json) => {
                        this.transactions = json.data.data;
                        this.status = 'ok';
                        callback();
                    }
                );
            },
            resetQuery() {
                this.filter_status = null;
                $('[data-id="filter_status"] .filter-option-inner-inner').text("وضعیت");
                $('[data-id="filter_type"] .filter-option-inner-inner').text("نوع");
                this.filter_from_amount = null;
                this.filter_to_amount = null;
                this.filter_from_date = null;
                this.filter_to_date = null;
                this.sort_field = null;
                this.filter_iban = '';
                this.filter_transaction_hashid = '';
                this.filter_type = null;
                this.filter_destination_last_name = '';
                this.filter_user_track_id = '';
            },
            reset_and_get() {
                this.resetQuery();
                this.get_data(this.transactions.path + "?page=1");
            },
            get_back() {
                this.$router.back();
            },
            fetchSettlementData(transaction) {
                this.fetchSettlement = {
                    settlement_withdraw_type: '',
                    total_amount: '',
                    status: null,
                    ref_code: '',
                    transfer_description: '',
                    user_track_id: '',
                    settlement_data: {
                        destination_firstname: '',
                        destination_lastname: '',
                        destination_number: '',
                        amount: '',
                        track_id: '',
                    },
                    before_balance: '',
                    after_balance: '',
                };
                
                Axios.get(`wallet/ayande/settlement-detail/${transaction.id}`)
                    .then((response) => {
                        this.fetchSettlement = {
                            ...response.data.data,
                            id: transaction.id
                        };
                    })
                    .catch((error) => {
                        console.log(error);
                    })

                this.settlementType = true;
                this.transferType = false;
            },
            fetchTrx(transaction) {
              Axios.get(`wallet/ayande/settlement-detail/${transaction.id}`)
                  .then((response) => {
                    this.fetchTransaction = {
                      ...response.data.data,
                      id: transaction.id
                    };
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              this.transferType = true;
              this.settlementType = false;
            },
            fetchTransactionData(transaction) {
                Axios.get(`wallet/ayande/settlement-detail/${transaction.id}`)
                    .then((response) => {
                        this.fetchTransfer = {
                            ...response.data.data,
                            id: transaction.id
                        };
                    })
                    .catch((error) => {
                        console.log(error);
                    });
                this.transferType = true;
                this.settlementType = false;
            },
            copyText(text , id = 'btn_copy_wallet_hashid') {
                navigator.clipboard.writeText(
                    text
                );
                let el = document.getElementById(id);
                el.classList.remove('fa-copy');
                el.classList.add('fa-check');

                setTimeout(() => {
                    el.classList.remove('fa-check');
                    el.classList.add('fa-copy');
                }, 1500);
            },
            copyTextTransfer(text) {
                navigator.clipboard.writeText(
                    'https://my.paystar.ir/wallets/settlement-receipt/' + text
                );
                let el = document.getElementById('btn_copy_wallet_hashid_transfer');
                el.classList.remove('fa-copy');
                el.classList.add('fa-check');

                setTimeout(() => {
                    el.classList.remove('fa-check');
                    el.classList.add('fa-copy');
                }, 1500);
            },
            getSettlementList() {
                let url;
                if (this.filter_transaction_hashid) {
                    url = `wallet/ayande/settlement-list/${this.wallet_hashid}?query[transaction_hashid]=${this.filter_transaction_hashid}`
                } else {
                    url = `wallet/ayande/settlement-list/${this.wallet_hashid}`
                }
                Axios.get(url)
                    .then((res) => {
                        this.transactions = res.data.data;
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            }
        },
        computed: {
            walletTransactionType() {
                return walletTransactionType
            },
            TwoFactorType() {
                return TwoFactorType
            },
            walletTransactionStatus() {
                return walletTransactionStatus
            },
            transactionStatus() {
                return transactionStatus
            },
            query() {
                let res = "";

                if (this.filter_status != null) {
                    res = res + "&query[status]=" + this.filter_status;
                }

                if (this.filter_from_amount != null) {
                    res = res + "&query[min_amount]=" + this.filter_from_amount;
                }

                if (this.filter_to_amount != null) {
                    res = res + "&query[max_amount]=" + this.filter_to_amount;
                }

                if (this.filter_transaction_hashid != '') {
                    res = res + "&query[transaction_hashid]=" + this.filter_transaction_hashid;
                }
                
                if (this.filter_type != null) {
                    res = res + "&query[transaction_type]=" + this.filter_type
                }

                if (this.filter_iban != '') {
                    res = res + "&query[iban]=" + this.filter_iban;
                }

                if (this.filter_destination_last_name != '') {
                    res = res + "&query[destination_last_name]=" + this.filter_destination_last_name;
                }

                if (this.filter_user_track_id != '') {
                    res = res + "&query[user_track_id]=" + this.filter_user_track_id;
                }

                if (this.filter_from_date != null) {
                    res = res + "&query[from_date]=" + this.filter_from_date;
                }

                if (this.filter_to_date != null) {
                    res = res + "&query[to_date]=" + this.filter_to_date;
                }

                if (this.sort_field != null) {
                    res = res + "&sort[field]=" + this.sort_field + "&sort[sort]=" + this.sort_sort;
                }

                return res;
            },
            queryForExcel() {
                let res = 'query[transaction_type]=300';

                if (this.filter_status != null && this.filter_status !== '') {
                    res = res + "&query[status]=" + this.filter_status;
                }

                if (this.filter_from_date != null && this.filter_from_date !== '') {
                    res = res + "&query[from_date]=" + this.filter_from_date;
                }

                if (this.filter_transaction_hashid != '') {
                    res = res + "&query[transaction_hashid]=" + this.filter_transaction_hashid;
                }

                if (this.filter_iban != '') {
                    res = res + "&query[iban]=" + this.filter_iban;
                }

                if (this.filter_destination_last_name != '') {
                    res = res + "&query[destination_last_name]=" + this.filter_destination_last_name;
                }

                if (this.filter_user_track_id != '') {
                    res = res + "&query[user_track_id]=" + this.filter_user_track_id;
                }

                if (this.filter_to_date != null && this.filter_to_date !== '') {
                    res = res + "&query[to_date]=" + this.filter_to_date;
                }

                if (this.sort_field != null && this.sort_field !== '') {
                    res = res + "&sort[field]=" + this.sort_field + "&sort[sort]=" + this.sort_sort;
                }

                return res;
            },
            wallet_hashid() {
                if (this.$route.params.hashid) return this.$route.params.hashid;

                return '';
            },
        },
        mounted() {
            this.getSettlementList();

            Axios.get('wallet/common?wallet_prefix=A').then(response => {
                response.data.data.forEach(wallet => {
                    if (wallet.id === this.$route.params.hashid) {
                        this.should_two_factor_settlement = wallet.should_two_factor_settlement;
                        this.form_data.should_two_factor_settlement = wallet.should_two_factor_settlement;
                    }
                })
            });
        }
    };
</script>
<style scoped>
.link {
    color: #0f9af0 !important;
    cursor: pointer;
}

.link:hover{
    border-bottom: 1px solid #0f9af0;
}
</style>
